export const extensionRoutes = [  {
    path: 'extensions/ecommerce',
    loadChildren: () => import('./extensions/3c85c48b4cdc1012b218fdaf37bb540b650116e12e560bfe88e79dc60922f4af/ecommerce-common-ui.module').then(m => m.EcommerceUICommonModule),
  },
  {
    path: 'extensions/after-sale',
    loadChildren: () => import('./extensions/ac7e338a92246c4e298742344bb4f67d9e5ee41bf15310cd2c1b13af73d69898/after-sale-ui.module').then(m => m.AfterSaleUiModule),
  }];
